module.exports = require('react/lib/ReactCSSTransitionGroup');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-addons-css-transition-group/index.js
 ** module id = ./node_modules/react-addons-css-transition-group/index.js
 ** module chunks = 1
 **/